// Load core bootstrap setup and Echo
import * as ERPHelpers from './helpers';
window.ERPHelpers = ERPHelpers;
import './bootstrap';
import './echo';

// Import SweetAlert2 Service - MUST be after bootstrap.js
import './pages/sweet-alert.js';

// === Vite-compatible plugin imports ===
import 'daterangepicker/daterangepicker.css';
import 'daterangepicker';
import 'bootstrap-datepicker';

// DataTables core + Bootstrap 5 styling
import 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.html5.min.js';
import 'datatables.net-buttons/js/buttons.print.min.js';
import 'datatables.net-buttons/js/buttons.colVis.min.js';
import 'datatables.net-buttons/js/buttons.html5.js';

import jszip from 'jszip';
window.JSZip = jszip;

// === Optional: Custom scripts and global objects ===
// SweetAlert is loaded in bootstrap.js, no need to import again
import ace from 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-monokai';
window.ace = ace;

// === Alpine and custom Alpine components ===
import Alpine from 'alpinejs';
window.Alpine = Alpine;

import leadsComponent from './alpine-components/leads.js';
import leadModalComponent from './alpine-components/leadModalComponent.js';
import ordersComponent from './alpine-components/orders.js';
import campaignAnalytics from './alpine-components/campaign-analytics.js';
import campaignReports from './alpine-components/campaign-reports.js';
import task from './alpine-components/tasks.js';
import initMainWarehouseStocks from './alpine-components/stock/main-warehouse-stocks.js';
import region from './alpine-components/regions.js';
import initSubWarehouseStocks from './alpine-components/stock/sub-warehouse-stocks.js';
import initShippingCompanyStocks from './alpine-components/stock/shipping-company-stocks.js';
import transactionsStockComponent from './alpine-components/transactions-stocks.js';
import employeeReport from './alpine-components/employees-reports.js';
import leadReport from './alpine-components/lead-reports.js';
import notificationComponent from './alpine-components/notificationComponent.js';
import shippingAppOrdersComponent from './alpine-components/shipping-agent/orders.js';
import shippingAppStocksComponent from './alpine-components/shipping-agent/stock.js';
import supervisorDashboard from './alpine-components/supervisor-dashboard.js';

// === Alpine component registration ===
document.addEventListener('alpine:init', () => {
    Alpine.data('leadsComponent', leadsComponent);
    Alpine.data('leadModalComponent', leadModalComponent);
    Alpine.data('ordersComponent', ordersComponent);
    Alpine.data('campaignAnalytics', campaignAnalytics);
    Alpine.data('campaignReports', campaignReports);
    Alpine.data('task', task);
    Alpine.data('initMainWarehouseStocks', initMainWarehouseStocks);
    Alpine.data('region', region);
    Alpine.data('initSubWarehouseStocks', initSubWarehouseStocks);
    Alpine.data('initShippingCompanyStocks', initShippingCompanyStocks);
    Alpine.data('transactionsStockComponent', transactionsStockComponent);
    Alpine.data('employeeReport', employeeReport);
    Alpine.data('leadReport', leadReport);
    Alpine.data('shippingAppOrdersComponent', shippingAppOrdersComponent);
    Alpine.data('shippingAppStocksComponent', shippingAppStocksComponent);
    Alpine.data('notificationComponent', notificationComponent); // ✅ Ensure this is included
    Alpine.data('supervisorDashboard', supervisorDashboard);
});

Alpine.start();

// === Bootstrap for popovers/tooltips ===
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// === jQuery plugin initialization ===
// document.addEventListener('DOMContentReady', function () {
//     $('.select2').select2({
//         theme: 'bootstrap-5',
//         placeholder: "Select an option",
//         allowClear: true,
//         width: '100%'
//     });
// });
